import axiosBackEnd from "../config/axios/axios-back-end";

export const removeFromEnvelopSigners = async ({ id }) => {
  const result = await axiosBackEnd.delete(`/api/users/${id}/envelope-signers`);
  return result.data;
};

export default { removeFromEnvelopSigners };
